export let showMorePost = {
	nav: function(){
		let $moreButtons = document.querySelectorAll("[data-more]");
		//console.log("show more button:", $moreButtons)
		$moreButtons.forEach( ($btn, index) => {
			$btn.removeEventListener("click", showMorePost.show, false);
			$btn.addEventListener("click", showMorePost.show, false);
		});
	},
	show: function(e){
		e.preventDefault();
		let $blockID = this.getAttribute("data-more");
		let $target = document.querySelector("." + $blockID);
		//console.log($blockID, $target);
		$target.classList.remove("hide_more");
		this.remove();
	}
}